import React from "react";
import './Location.css';

const LOCAIS = [
    {
        local: 'Marinha Grande',
        espaco: 'Escola HM',
        morada: 'R. Diogo Stephens n.º 25, Marinha Grande',
        mapa: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6135.24782177426!2d-8.93565691128519!3d39.748098135507234!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd2273028f48e7eb%3A0x7b55e76d85af835!2sEscola%20kickboxing%20e%20Muay%20Thai%20Hugo%20Matos!5e0!3m2!1spt-PT!2spt!4v1729875726222!5m2!1spt-PT!2spt',
    },
    {
        local: 'Fátima',
        morada: 'R. do Cabecinho, Fátima',
        mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12294.661125429751!2d-8.681857580822523!3d39.61222197776564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd189cd9e659c0c1%3A0xb1a11b33dc088b8a!2sR.%20do%20Cabecinho%202%2C%20Casa%20Velha%2C%202495-350%20F%C3%A1tima!5e0!3m2!1spt-PT!2spt!4v1792274350860!5m2!1spt-PT!2spt',
    },
    {
        local: 'Caxarias',
        espaco: 'Be Pragmatic',
        morada: 'R. dos Combatentes 101, 2435-125 Caxarias',
        mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12276.918466670206!2d-8.548829680750288!3d39.71202215361241!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd227f0066c3eb6b%3A0x8c477648b56f4b52!2sBe%20Pragmatic!5e0!3m2!1spt-PT!2spt!4v1792274203563!5m2!1spt-PT!2spt',
    },
    {
        local: 'São Martinho do Porto',
        morada: 'R. Águas Belas 10, São Martinho do Porto',
        mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2829.6807435958444!2d-9.135285124348117!3d39.510435571599594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd18ac4513a7cdaf%3A0x52f40d7bd3496a2c!2sR.%20%C3%81guas%20Belas%2010%2C%202460-635%20S%C3%A3o%20Martinho%20do%20Porto!5e1!3m2!1spt-PT!2spt!4v1781186977596!5m2!1spt-PT!2spt',
    },
];

const Location = () => {
    return (
        <section id="location" className="s_location">
            <h2 className="section-title">Locais</h2>
            <ul className="card-grid">
                {LOCAIS.map(({ local, espaco, morada, mapa }) => (
                    <li key={local} className="info-card location-card">
                        <h3>{local}</h3>
                        <iframe
                            className="maps"
                            title={`Mapa — ${local}`}
                            src={mapa}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                        <address>
                            {espaco && <span className="espaco">{espaco}</span>}
                            {morada}
                        </address>
                        <a
                            className="map-link"
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(morada)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Abrir no Google Maps
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Location;
